import styled from "styled-components";
import breakpoints from "../../constants/breakpoints";

export const Styles = styled.div`
  /* position: absolute;
  top: 0;
  left: 0;
  right: 0; */
  background: ${({ isOpen }) => (isOpen ? "var(--main-color)" : "transparent")};
  z-index: 1000;
  width: 100%;
  transition: background-color 0.3s ease;
  position: absolute;
  top: 0;

  .navbar {
    background: transparent !important;
    border: none !important;
  }

  .navbar-toggler {
    border: 1px solid white;
    color: white;

    &:focus {
      box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.25);
    }

    .navbar-toggler-icon {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
    }
  }

  .container {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 1rem calc(var(--bs-gutter-x) * 0.5);
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
    padding-top: 0;
    padding-bottom: 0;

    .logo {
      padding: 10px 0;
    }

    .logo-container {
      text-decoration: none;

      img {
        object-fit: contain;
        height: 130px;
      }
    }

    .nav-ddl,
    .nav-dropdown {
      &:hover {
        > a {
          color: white !important;
        }
      }
    }

    .nav-link {
      padding: 0 !important;
      color: white;
      height: 86px;
      display: flex;
      justify-content: start;
      align-items: center;
      font-weight: 500;
      text-transform: capitalize;
      position: relative;
      font-size: 1.3rem;
      &:hover {
        color: var(--secondary-color) !important;
        &.active {
          color: var(--secondary-color) !important;
        }
      }
      &::before {
        content: "";
        position: absolute;
        bottom: 25px;
        width: 100%;
        height: 2px;
        background-color: var(--secondary-color);
        transform: scaleX(0);
        transform-origin: left;
        transition: transform 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);
      }
      &:hover::before,
      .underline-item.active::before {
        transform: scaleX(1);
        background-color: var(--secondary-color);
      }
      &.active {
        color: white !important;
      }
    }

    /* .active-link {
      color: white !important;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        bottom: 25px;
        height: 2px;
        transform: scaleX(0);
        transform-origin: left;
        transition: transform 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);
        transform: scaleX(1);
        background-color: white;
      }
    } */

    .controllers {
      display: flex;
      align-items: center;
      list-style: none;
      gap: 1rem;

      .lang-list span {
        color: white;
      }
    }
  }

  .navbar-expand-lg .navbar-collapse {
    justify-content: center;

    .navbar-nav {
      ${({ isAr }) => isAr && "margin:0 !important"};
      justify-content: start;
    }
  }

  .navbar-nav {
    flex-direction: row;
    text-transform: capitalize;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: end;
    column-gap: 2rem;
    width: 100%;

    li {
      font-weight: 600;

      :hover {
        color: white;
      }
    }
  }

  .dropdown-item.active,
  .dropdown-item:active {
    /* background-color: var(--bg-input); */
  }

  @media (min-width: ${breakpoints.xl}) {
    .dropdown-menu {
      top: 48px;
      padding: 0;
      background: white;

      .dropdown-item {
        border-top: 1px solid gray;
        border-width: 1px 0;
        padding: 0.5rem 1rem;
        transition: all ease-in-out 0.3s;
        color: #161616;

        &:hover {
          background: var(--main-color);
          color: white;
        }
      }
    }
  }

  @media (max-width: ${breakpoints.xl}) {
    .container {
      align-items: baseline;
    }
    .navbar {
      .container {
        padding: 0;
      }
    }
    .navbar-expand-lg .navbar-collapse {
      margin-top: 2rem;
    }
  }

  @media (max-width: ${breakpoints.xl}) {
    .navbar-nav {
      display: unset;
      padding: 0;
    }
    .nav-link {
      height: 50px !important;
    }
    .controllers {
      align-items: center;
      height: 50px;
      padding: 0 !important;
      margin: 0 !important;
      > div {
        padding: 0;
      }
    }
    .navbar-collapse.collapsing {
      /* max-height: 200px !important; */
      /* transition: all ease 0.35s !important; */
    }
    .nav-link {
      padding: 0;
      height: 50px;
      justify-content: start;
    }

    .container {
      .navbar {
        width: auto;
      }

      .lang-list {
        text-align: start;
      }
    }
  }

  @media (min-width: ${breakpoints.md}) {
    .container {
      justify-content: space-between;
    }
    .navbar-collapse {
      ${({ isAr }) => (isAr ? "left: -3rem;" : " left: -8rem;")};
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    .container {
      .navbar-collapse {
        position: unset !important;
        overflow: hidden;
      }
      .navbar-collapse.collapsing {
        /* max-height: 160px !important; */
      }
      .nav-link {
        height: 40px;
      }
      .controllers {
        height: 40px;
      }
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    .container {
      justify-content: space-between;
      position: relative;

      .navbar-collapse {
        /* margin-top: -1rem !important; */
        /* left: -10rem; */
        /* position: absolute !important; */
      }
      .controllers {
        margin: 0;
        padding-bottom: 5px !important;
        flex-direction: column;
        gap: 1rem;
        align-items: start;
      }
      .navbar {
        /* width: 100%; */
      }
    }
  }

  .navbar .navbar-brand {
    width: 15%;
    height: 15%;
    img {
      width: 100%;
      object-fit: cover;
    }
  }

  .nextgen-logo {
    width: 150.46px;
    height: 62.74px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .shababek-logo-container {
    width: 86.81px;
    height: 62.74px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  @media (min-width: ${breakpoints.xl}) {
    .container {
      /* padding: 0; */
    }

    .navbar-brand:last-child {
      width: 7%;
      margin: 0;
    }

    .dropdown-menu {
      top: 54px;
      border-radius: 0;
    }
  }

  @media (max-width: 1200px) {
    .navbar-brand:last-child {
      display: flex;
      justify-content: end;
      margin: 0;
    }
  }

  @media (max-width: ${breakpoints.xl}) {
    .nav-link {
      &::before {
        bottom: 5px !important;
      }
    }
  }

  @media (max-width: ${breakpoints.xl}) {
    .navbar-nav {
      justify-content: space-between;
      gap: 1rem;
      flex-wrap: wrap;
    }

    .navbar .nav-link,
    .container .controllers .lang-list span {
      color: white;
    }

    .navbar-toggler:focus {
      text-decoration: none;
      outline: 0;
      box-shadow: 0 0 0 var(--main-color);
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    .navbar-nav {
      flex-direction: column;
      gap: 0rem;
    }
    .container .nav-link:hover {
      color: white;
      &::before {
        display: none;
      }
    }
    .navbar .navbar-brand {
      width: 50%;
      height: 50%;
    }
  }
`;
